// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__-d5oQ","col":"styles_col__2pw_8"};